import React, { Fragment } from 'react'
import { Input } from 'loyal-react'
import PropTypes from 'prop-types'
import './Input.css'

const Individual = ({
  participant,
  errors,
  disabled,
  personalEmail,
  mobilePhone,
  updateState
}) => {
  return (
    <Fragment>
      <div className='col-md-6'>
        <Input
          id='name'
          label='Nome'
          value={participant.name}
          aria-required
          data-error='Digite um Nome e Sobrenome válidos'
          valid={errors.name}
          disabled={disabled.name}
          onChange={(e) => updateState('name', e.target.value, true)}
        />
      </div>
      <div className='col-md-6 dynamic-margin'>
        <Input
          id='documentNumber'
          label='CPF'
          mask={[/\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '-', /\d/, /\d/]}
          aria-required
          value={participant.documentNumber}
          valid={errors.documentNumber}
          error='Digite um Documento válido'
          disabled={disabled.documentNumber}
          onChange={(e) => updateState('documentNumber', e.target.value, true)}
        />
      </div>
      <div className='col-md-3 col-sm-6 mt-2'>
        <Input
          id='birthDate'
          label='Data de nascimento'
          mask={
            [/[0-3]/,
              /[0-9]/,
              '/',
              /[0-1]/,
              /[0-9]/,
              '/',
              /[1-2]/,
              /[0-9]/,
              /[0-9]/,
              /[0-9]/
            ]}
          aria-required
          value={participant.birthDate}
          valid={errors.birthDate}
          data-error='Digite uma Data válida'
          disabled={disabled.birthDate}
          onChange={(e) => updateState('birthDate', e.target.value, true)}
        />
      </div>
    </Fragment>
  )
}

Individual.propTypes = {
  participant: PropTypes.object,
  errors: PropTypes.object,
  disabled: PropTypes.object,
  mobilePhone: PropTypes.string,
  personalEmail: PropTypes.string,
  updateState: PropTypes.func
}

export default Individual



// WEBPACK FOOTER //
// ./src/features/UserInfosValidation/Individual.js